import { Form } from 'antd';
import FrequencyField from 'components/lib/formFields/FrequencyField';
import { NEW_PACKAGE_INSTRUCTION_FIELDS } from '../utils';

interface PackageTaskFormProps {
    instructionName: string;
}

const PackageTaskForm: React.FC<PackageTaskFormProps> = ({ instructionName }) => {
    return (
        <>
            <Form.Item label='Order'>{instructionName}</Form.Item>
            <FrequencyField label='Frequency' name={NEW_PACKAGE_INSTRUCTION_FIELDS.FREQUENCY} />
        </>
    );
};

export default PackageTaskForm;
